import { ISLMap } from 'src/app/types/@types/sl-map';
import { getGeom } from '@turf/invariant';
import { LayerGeomtypes } from 'src/app/model/sl-layer';
import { EventEmitter, Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { Decorable } from 'src/app/types/decorable';
import { MapService } from 'src/app/services/map.service';
import { CancellablePromise, ICancellablePromise } from 'src/app/types/cancellable-promise';
import { SLLayer } from '../sl-layer';
// @ts-ignore
import { LngLat, Point } from '!mapbox-gl';
import { SLMap } from '../sl-map';
import { AnyHandler, BBOXArray, SimpleAVHandler } from '../../types/@types/sl-v-types';
import { UUID } from 'angular2-uuid';
import * as turf from '@turf/turf';

@Injectable({
  providedIn: 'root'
})
export class SnapLayerAPIService {
  public snapPtsId;
  public snapSegsId;
  private map: ISLMap;
  private snapSrc: SLLayer;
  private snapPoints: Array<{ lng: number, lat: number }> = [];
  private snapSegments: Array<Array<{ lng: number, lat: number }>> = [];
  public loadingSnapPts: boolean = false;
  public loadingSnapSegs: boolean = false;
  public bufferDistance: number = 0;
  public bbox:Array<number> = [];

  private static handlers: { [key:string]: SimpleAVHandler<SnapLayerAPIService>} = {};
  constructor(private wapi: SlWapiService) {
    console.log('snap layer api');
  }
  AddLoadListener(id: string, handler: SimpleAVHandler<SnapLayerAPIService>) {
    SnapLayerAPIService.handlers[id] = handler;
  }
  RemoveLoadListener(id:string) {
    if(!!SnapLayerAPIService.handlers[id]) {
      delete SnapLayerAPIService.handlers[id];
    }
  }
  SetBufferDistance(meterDistance: number) {
    this.bufferDistance = meterDistance;
  }
  SelectSnapLayer(layer: SLLayer) {
    if (!!this.snapSrc) {
      if (!((this.snapSrc.identifier !== layer.identifier))) {
        return; // already snap layer.
      }
    }
    this.snapPoints = [];
    this.snapSegments = [];
    this.snapSrc = layer;
    this.map = layer.map;
    this.RefreshSnaps();
  }
  RefreshSnaps() {
    if(!this.snapSrc) return;
    this.snapPoints = [];
    this.snapSegments = [];
    if (this.snapSrc.geom === 'point') {
      this.LoadSnapPoints();
    } else {
      this.LoadSnapPoints();
      this.LoadSnapSegments();
    }
  }
  UpdateIfReady() {
    if (this.loadingSnapPts || this.loadingSnapSegs) return;
    for(const handlerId in SnapLayerAPIService.handlers) {
      if(!SnapLayerAPIService.handlers[handlerId]) continue;
      const handler:SimpleAVHandler<SnapLayerAPIService> = SnapLayerAPIService.handlers[handlerId];
      handler(this);
    }
  }
  LoadSnapPoints() {

    const params: any = { bbox: this.GetBBOX() }
    params.player_id = this.snapSrc.identifier;
    params.pt_format = 'text';
    this.wapi.Post('layers/layer/get-snaps', params).then((response) => {
      this.loadingSnapPts = false;
      this.snapPtsId = UUID.UUID();
      this.snapPoints = !!response.results?.length ? response.results : [];
      this.UpdateIfReady();
    })
  }
  LoadSnapSegments() {
    this.loadingSnapSegs = true;
    const params: any = { bbox:this.GetBBOX()}
    params.player_id = this.snapSrc.identifier;
    params.pt_format = 'text';

    this.wapi.Post('layers/layer/get-snap-segs', params).then((response) => {
      this.snapSegsId = UUID.UUID();
      this.snapSegments = (!!response.results?.length) ? response.results : [];
      this.loadingSnapSegs = false;
      this.UpdateIfReady();

    });

  }
  GetSnapPoints(): Array<{ lng: number, lat: number }> {
    if (!this.snapPoints) return [];
    return this.snapPoints;
  }
  GetSnapSegments(): Array<Array<{ lng: number, lat: number }>> {
    if (!this.snapSegments) return;
    return this.snapSegments;
  }
  GetSnapLayer():SLLayer | undefined {
    return this.snapSrc;
  }
  SetBBOX(bbox?:Array<number>){
    this.bbox = !!bbox ? bbox : [];
  }
  GetBBOX() {
    const val = this.bufferDistance/1000;
    if(!this.snapSrc?.map?.ui) return [];
    const center = this.snapSrc.map.ui.getCenter();
    const centerPt = turf.point([center.lng, center.lat])
    const north = turf.destination(centerPt, val, 0,{units:'kilometers'});
    const east = turf.destination(centerPt, val, 90,{units:'kilometers'});
    const south = turf.destination(centerPt, val, 180,{units:'kilometers'});
    const west = turf.destination(centerPt, val, 270,{units:'kilometers'});
    const featureCollection = turf.featureCollection([north, east, south, west]);
    // Calculate the bounding box (envelope) for the feature collection
    this.bbox = turf.bbox(featureCollection);
    return this.bbox;
  }

}
